import overrides from '../common/common';
import { ThemeOverrides } from '../themeTypes';

export default {
    ...overrides,
} as ThemeOverrides;
